export default "__VITE_ASSET__BtfhhvMw__";